import React from "react";
import LeftBanner from "./LeftBanner";
import RightBanner from "./RightBanner";
const MyBanner = () => {
  return (
    <section
      id="home"
      className="w-full py-20 flex flex-col lgl:flex-row items-center border-b-[1px] font-titleFont border-b-black"
    >
      <LeftBanner />
      <RightBanner />
    </section>
  );
};

export default MyBanner;
